import Vue from 'vue';
import Tip from './Tip.vue';

const TipBox = Vue.extend(Tip);
Tip.install = (title, options) => {
    const newOptions = Object.assign({
        title,
    }, options);
    const instance = new TipBox({
        data: newOptions,
    }).$mount();
    console.log(instance)
    document.body.appendChild(instance.$el);
    return instance.tip();
};
export default Tip
